"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _richTextField = require("../../lib/richTextField");
var _LoadableComponent = _interopRequireDefault(require("../../components/LoadableComponent"));
var _TitleTaglineDisplay = _interopRequireDefault(require("../TitleTaglineDisplay"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a tab navigation
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A tab navigation
 */
function TabNavVertical(props) {
  var extractedFields, componentParam;
  var getURLQuery = new URLSearchParams(props.params.pageQuery);
  var tabIndex = getURLQuery.get('tab');
  var TabContent = props => {
    if (props.IsContentDynamic.value) {
      if (!(0, _lodash.isEmpty)(props.ContentMainDynamic)) return /*#__PURE__*/_react.default.createElement(TabContentDynamic, props);else return null;
    } else return /*#__PURE__*/_react.default.createElement(TabContentStatic, props);
  };
  var TabContentDynamic = props => {
    var _props$ContentMainDyn;
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 12
    }, /*#__PURE__*/_react.default.createElement(_LoadableComponent.default, {
      name: (_props$ContentMainDyn = props.ContentMainDynamic.fields.ComponentName) === null || _props$ContentMainDyn === void 0 ? void 0 : _props$ContentMainDyn.value,
      rendering: props.ContentMainDynamic,
      params: componentParam,
      parentComponent: "tab"
    })));
  };
  var TabContentStatic = props => {
    return (0, _richTextField.parseHTML)(props.ContentStatic);
  };
  var TabTitleTagline = props => {
    if ((0, _lodash.isNil)(props) || (0, _lodash.isNil)(props.fields)) return null;else {
      var propRendering = {
        fields: props.fields,
        dataSource: props.id
      };
      return /*#__PURE__*/_react.default.createElement(_TitleTaglineDisplay.default, {
        rendering: propRendering,
        params: ''
      });
    }
  };
  if (props.rendering.fields) {
    extractedFields = (0, _utils.extractFieldsFn)(props);
    componentParam = props.params;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
      className: 'app-container vertical-tabs card card--basic'
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, !(0, _lodash.isEmpty)(extractedFields.Eyebrow.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, extractedFields.Eyebrow.value), /*#__PURE__*/_react.default.createElement(TabTitleTagline, extractedFields.TitleTagline), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs, {
      defaultKey: tabIndex === null || tabIndex > extractedFields.Tabs.length - 1 || isNaN(tabIndex) ? '0' : tabIndex
    }, extractedFields.Tabs.map((tabList, key) => {
      return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Tabs.Tab, {
        eventKey: key,
        title: tabList.fields.Title.value
      }, /*#__PURE__*/_react.default.createElement(TabContent, tabList.fields));
    }))));
  } else return null;
}
var _default = exports.default = TabNavVertical;